import React from 'react'
import PropTypes from 'prop-types'
import styles from './_caption.css'

function Caption (props) {
  const {
    children,
    align,
    color,
  } = props

  const inlineStyles = {
    color: color || 'black',
  }

  const alignClass = align ? `align--${align}` : 'align--left'

  return (
    <p className={`${styles.caption} ${styles[alignClass]}`} style={inlineStyles}>
      {children}
    </p>
  )
}

Caption.propTypes = {
  align: PropTypes.string,
  children: PropTypes.node,
  color: PropTypes.string,
}

export default Caption



// WEBPACK FOOTER //
// ./src/components/app-page/shared/Caption/index.jsx